
        var result = require("!!../../../../node_modules/css-loader/index.js!./event-form.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/event-form/event-form.component.css
// module id = 1413
// module chunks = 0